


























import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class DiagramLegendTable extends Vue {
  @Prop({required: true, type: Array})
  items!: [];

  @Prop({required: true, type: Array})
  labels!: [];

  @Prop({required: true, type: String})
  colorFieldName!: null;
}
